import { render, staticRenderFns } from "./AccessControlTab.vue?vue&type=template&id=b5f7f3b2&scoped=true"
import script from "./AccessControlTab.vue?vue&type=script&lang=js"
export * from "./AccessControlTab.vue?vue&type=script&lang=js"
import style0 from "./AccessControlTab.vue?vue&type=style&index=0&id=b5f7f3b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f7f3b2",
  null
  
)

export default component.exports